import { Injectable } from '@angular/core';
import { LoadingService } from './loading.service';
import { OutletDealzService } from './outlet-dealz.service';
import { HapticsService } from './haptics.service';
import { LoyaltyCardService } from './loyalty-card.service';
import { LoyaltyCardPreviewComponent } from '../shared/components/loyalty-card-preview/loyalty-card-preview.component';
import { OneTimeStampQrCode } from '../models/interfaces';
import { ModalController } from '@ionic/angular';
import { DateTimeService } from './date-time.service';
import { LandingPage } from '../pages/landing/landing.page';
import { WalletPage } from '../pages/wallet/wallet.page';
import { AuthService } from './auth.service';
import { ToastServiceService } from './toast-service.service';
import { VouchersService } from './vouchers.service';
import { DatabaseService } from './database.service';
import { ConfettiService } from './confetti.service';
import { AlertService } from './alert.service';
import { KeyringService } from './keyring.service';
import { CloudfunctriggersService } from './cloudfunctriggers.service';
import { WalletService } from './wallet.service';
import { PushNotificationsService } from './pushnotifications.service';

@Injectable({
  providedIn: 'root'
})
export class QrCodeClaimsService {
  constructor(
    private loadingService:LoadingService,
    private outletService:OutletDealzService,
    private hapticsService:HapticsService,
    private loyaltyCardService:LoyaltyCardService,
    private modalController: ModalController,
    private dateTimeService:DateTimeService,
    private authService:AuthService,
    private toasts:ToastServiceService,
    private vouchersService:VouchersService,
    private dbService:DatabaseService,
    private confettiService:ConfettiService,
    private alertService:AlertService,
    private keyringService:KeyringService,
    private cloudFunctionTriggers:CloudfunctriggersService,
    private walletService:WalletService,
    private pushNotificationsService:PushNotificationsService
  ) { }



  async claimVoucher(voucherId:string){

    if(this.authService.isAnonUser()){
      this.toasts.showToast(
        'To claim a voucher please sign up or log in first',
        'Not signed in',
        async ()=>{
          await this.showLoginOptions();
        },
        'OK'
      )
      return
    }

    try {
      await this.loadingService.showOrContinueShowingLoading();
     // await this.loadingService.updateLoaderMessage('Fetching voucher...');
      const res = await this.vouchersService.claimVoucher(voucherId);
      await this.loadingService.hideLoading();
      if(res.data.voucher){
        await this.toasts.showToast(
          res.message ? res.message : 'Open your wallet to see any cards or vouchers you just earned',
          'Success!',
          async () =>{
            await this.walletService.checkWallet('vouchers')
          },
          'Open'
        )
        await this.celebrateWithConfetti(true);
        await this.askNotificationPermissions(res.data.voucher.restaurantUid) 
      }
     } catch (error) {
      console.log(error);
      await this.loadingService.hideLoading();
      await this.dbService.tryUploadScanError(
        error.message?error.message:error?JSON.stringify(error):'Undefined error',
        'Tried to claim voucher',
        'voucherId',
        voucherId,
        'QR'
      )   
      await this.toasts.showErrorToast(error.message?error.message:'Error claiming voucher');
     }
 
  }

  async claimCoupon(couponId:string){

    if(this.authService.isAnonUser()){
      await this.toasts.showToast(
        'To claim coupons please sign up or log in first',
        'Not signed in',
        async ()=>{
          await this.showLoginOptions();
        },
        'OK'
      )
      return
    }

    try {
      await this.loadingService.showOrContinueShowingLoading();
      //await this.loadingService.updateLoaderMessage('Fetching coupon...');
      const res = await this.cloudFunctionTriggers.claimCoupon(couponId);
      await this.loadingService.hideLoading();
      if(res.data.coupon){
        this.toasts.showToast(
          res.message ? res.message : 'Open your wallet to see your coupon',
          'Success!',
          async () =>{
            await this.walletService.checkWallet('coupons')
          },
          'Open'
        )
        await this.celebrateWithConfetti();  
        await this.askNotificationPermissions(res.data.coupon.restaurant_id);
      }
     } catch (error) {
      await this.loadingService.hideLoading();
      console.log(error);
      await this.dbService.tryUploadScanError(
        error.message?error.message:error?JSON.stringify(error):'Undefined error',
        'Tried to claim coupon from deeplink',
        'couponId',
        couponId,
        'QR'
      )   
      await this.toasts.showErrorToast(error.message?error.message:'Error claiming keyring');
     }
   
  }

  async claimSingleUseStampsQr(qrId:string){

    if(this.authService.isAnonUser()){
      await this.toasts.showToast(
        'To claim stamps please sign up or log in first',
        'Not signed in',
        async ()=>{
          await this.showLoginOptions();
        },
        'OK'
      )
      return
    }

    try {
      await this.loadingService.showOrContinueShowingLoading();
      //await this.loadingService.updateLoaderMessage('Fetching stamps...');
      const res = await this.cloudFunctionTriggers.claimStampsOnSingleUseQrCode(qrId);
      await this.loadingService.hideLoading();
      if(res.data.qrCode){
       
          await this.toasts.showToast(
             res.message ? res.message : 'Stamp(s) awarded.',
            'Success!'
          )
        
        if(!res.data.voucherAwarded){
          await this.viewUserCard(res.data.qrCode)
        }else{
          await this.walletService.checkWallet('vouchers')
        }
        await this.celebrateWithConfetti(res.data.voucherAwarded);
        await this.askNotificationPermissions(res.data.qrCode.outlet_group_id) 
      }
     } catch (error) {
      await this.loadingService.hideLoading();
      console.log(error);
      await this.dbService.tryUploadScanError(
        error.message?error.message:error?JSON.stringify(error):'Undefined error',
        'Tried to claim stamps qr',
        'stampQrCodeId',
        qrId,
        'QR'
      )   
      await this.toasts.showErrorToast(error.message?error.message:'Error claiming keyring');
     }
  
  }

  async claimKeyring(keyringId:string){

    if(this.authService.isAnonUser()){
      this.toasts.showToast(
        'To claim a keyring please sign up or log in first',
        'Not signed in',
        async ()=>{
          await this.showLoginOptions();
        },
        'OK'
      )
      return
    }

    try {
      await this.loadingService.showOrContinueShowingLoading();
     // await this.loadingService.updateLoaderMessage('Fetching keyring...');
      const res = await this.keyringService.claimkeyring(keyringId);
      await this.loadingService.hideLoading();
      if(res.data.keyring){
        await this.toasts.showToast(
          'You can now use either the keyring or the app to receive stamps. All loyalty cards and voucher that was on the keyring will now be in your wallet as well - check it out by clicking the gift icon on the bottom of the scan page.',
          'Keyring claimed!'
        )
      }
     } catch (error) {
      await this.loadingService.hideLoading();
      console.log(error);
      await this.dbService.tryUploadScanError(
        error.message?error.message:error?JSON.stringify(error):'Undefined error',
        'Tried to claim keyring',
        'keyringId',
        keyringId,
        'QR'
      )   
      await this.toasts.showErrorToast(error.message?error.message:'Error claiming keyring');
     }
 
  }

  async viewUserCard(stampQrCode:OneTimeStampQrCode) {
    try {
      await this.hapticsService.hapticsImpactLight();
      const deal = await this.outletService.fetchaSpecial(stampQrCode.shop_user_id,stampQrCode.outlet_group_id,stampQrCode.loyalty_programme_id)
      const card = await this.loyaltyCardService.giveCardInWalletForThisSpecial(deal);
      const outlet = await this.outletService.fetchOutlet(stampQrCode.shop_user_id,stampQrCode.outlet_group_id,stampQrCode.outlet_id);
      const modal = await this.modalController.create({
        component: LoyaltyCardPreviewComponent,
        mode: 'ios',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle: false,
        componentProps: {
          loyaltyCard: card,
          deal,
          outlet,
          today: this.dateTimeService.giveLocalNowDay()
        }
      });
      await modal.present();
     } catch (error) {
      console.log(error);
     }
  }

 private  async showLoginOptions() {
  const activeModal = await this.modalController.create({
    component: LandingPage,
    mode: 'ios',
    initialBreakpoint: 0.7,
    breakpoints: [0, 0.7],
    handle: false,
  });
  await activeModal.present();
  }

  private async celebrateWithConfetti(showVoucherAlert:boolean = false){
    try {
      if(showVoucherAlert){
        let interval = this.confettiService.confettiFireWorks(15);
        let alert = await this.alertService.receivedVoucherAlert();
        alert.onDidDismiss().then(() => {
          clearInterval(interval)
        })
      }else{
        this.confettiService.confettiCannonBurst(2,5,2)
      }
    } catch (error) {
      console.log(':( no confetti', error);
    }
  }

  private async askNotificationPermissions(shopId:string) {
    const notificationsEnabled = await this.pushNotificationsService.askForPermissions(false);
    if (notificationsEnabled) {
      try {
       await this.pushNotificationsService.subscribeToShopTopic(shopId);
      } catch (error) {
        console.log(error);
      }
    }
  }
}
